/**
 * Tutorial de onboarding (KAN-232) — registro de módulos.
 *
 * EL ORDEN DEL ARRAY ES EL ORDEN DE APRENDIZAJE sugerido (y la prioridad
 * del recordatorio). Cada módulo es INDEPENDIENTE: se puede hacer, re-ver
 * o mover de lugar sin depender de otro.
 *
 * Para agregar un módulo nuevo: creá su archivo en modules/ (copiá uno
 * existente), definí pasos con anclas `data-ar-guide` existentes (o
 * agregalas donde falten), y sumalo al array de abajo donde quieras que
 * aparezca. Nada más — hub, progreso, recordatorio y audio lo toman solo.
 *
 * El audio por paso es opcional: si existe el archivo
 * public/audio/tutorial/{moduleId}/{stepId}.mp3 el runner lo referencia;
 * si no, el paso sale mudo. Generación: scripts/generate-tutorial-audio.mjs.
 */

import type { TutorialGrupo, TutorialModuleDef } from '../../services/tutorial/types';
import { crearCampoModule } from './modules/crearCampo';
import { ubicacionesModule } from './modules/ubicaciones';
import { animalesModule } from './modules/animales';
import { paneoAppModule } from './modules/paneoApp';
import { puestoMapaModule } from './modules/puestoMapa';
import { sigsaModule } from './modules/sigsa';
import { compraVentaModule } from './modules/compraVenta';
import { administracionModule } from './modules/administracion';
import { reportesModule } from './modules/reportes';
import { utilidadesModule } from './modules/utilidades';
import { asistenteModule } from './modules/asistente';
import { balanzaModule } from './modules/balanza';
import { tactoModule } from './modules/tacto';
import { valuacionModule } from './modules/valuacion';
import { lluviasModule } from './modules/lluvias';
import { lectorHidModule } from './modules/lectorHid';
import { pesajesModule } from './modules/pesajes';
import { linajeModule } from './modules/linaje';
import { pwaModule } from './modules/pwa';
import { usuariosModule } from './modules/usuarios';

/**
 * Grupos del hub (alternativa A): el orden de los grupos Y el orden dentro
 * de cada uno son el orden de aprendizaje sugerido (el recordatorio sigue
 * esta secuencia). Los grupos se declaran en cada módulo (campo `grupo`).
 */
export const TUTORIAL_GRUPOS: { id: TutorialGrupo; label: string; emoji: string; hint: string }[] = [
  {
    id: 'esencial',
    label: 'Arranque esencial',
    emoji: '🌱',
    hint: 'Lo básico para tener el campo andando: animales, pesos, tacto, mapa y los números',
  },
  {
    id: 'negocio',
    label: 'El negocio',
    emoji: '💼',
    hint: 'Papeles, comercio y el valor de tu hacienda',
  },
  {
    id: 'produccion',
    label: 'Para producir mejor',
    emoji: '🚜',
    hint: 'Las herramientas que le sacan más jugo al campo',
  },
  {
    id: 'equipo',
    label: 'La app y tu equipo',
    emoji: '👥',
    hint: 'Instalala en tus dispositivos y suma a tu gente',
  },
];

/** Módulos del tutorial en orden de aprendizaje (agrupado). Reordenable/editable. */
export const TUTORIAL_MODULES: TutorialModuleDef[] = [
  // 🌱 Arranque esencial
  crearCampoModule,
  ubicacionesModule,
  animalesModule,
  paneoAppModule,
  pesajesModule,
  tactoModule,
  puestoMapaModule,
  administracionModule,
  // 💼 El negocio
  sigsaModule,
  compraVentaModule,
  valuacionModule,
  // 🚜 Para producir mejor
  balanzaModule,
  lectorHidModule,
  lluviasModule,
  linajeModule,
  reportesModule,
  utilidadesModule,
  // 👥 La app y tu equipo
  pwaModule,
  usuariosModule,
  asistenteModule,
];
